// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d-grid[data-v-58654d8a]{grid-template-columns:24px 1fr;grid-gap:0 16px}.icon-nutrition[data-v-58654d8a]{width:24px;height:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
